<template>
    <div>
        <b-button v-b-modal.modal-new-version class="btn btn-sm" variant="primary">
            <span class="fa fa-plus dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Add New Version</b-button>
        <b-modal id="modal-new-version" title="Add New Version" hide-backdrop @ok="onOk" @cancel="onCancel">
            <div>
                <h5>Country: {{country.name}}</h5>
                <h5>Brand: {{brand.name}}</h5>
            </div>
            <form ref="versionForm" action="/create-versions/store" method="POST">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="country_id" :value="country.id">
                <input type="hidden" name="brand_id" :value="brand.id">
                <b-form-select v-model="selectedModel" :options="models" @change="onModelSelectChange" name="model_id"></b-form-select>
                <b-form-input v-if="selectedModel===0" class="mt-3" id="new_model_name" name="new_model_name" v-model="newModelName" @input="onNewModelInput" placeholder="Enter the name for the new model"></b-form-input>

                <template v-if="localVersions.length">
                    <h6 class="mt-3">Restore Discontinued Version</h6>
                    <div v-for="localVersion in localVersions" :key="'local_versions__' + localVersion.id">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <b-form-radio v-model="selectedVersion" name="local_version" :value="'local_version__' + localVersion.id"></b-form-radio>
                            </div>
                            <div class="btn btn-outline-primary btn-block dc7-btn-left dc7-btn-outline-mcd" data-toggle="collapse" :data-target="'#collapse' + localVersion.id" aria-expanded="false" aria-controls="collapseExample">
                                &nbsp;{{localVersion.id}}&nbsp;-&nbsp;{{localVersion.name}}
                                <span class="badge badge-primary badge-pill">{{localVersion.price_count}}</span>
                            </div>
                        </div>
                        <div class="collapse" :id="'collapse' + localVersion.id">
                            <div class="card card-body dc7-btn-card">{{localVersion.cc}}cc {{Math.round(localVersion.hp)}} hp (&Dagger; {{localVersion.price_month}})</div>
                        </div>
                    </div>
                </template>

                <template v-if="globalVersions.length">
                    <h6 class="mt-3">Create from global version</h6>
                    <div v-for="globalVersion in globalVersions" :key="'versions__' + globalVersion.id">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <b-form-radio v-model="selectedVersion" name="version" :value="'version__' + globalVersion.id"></b-form-radio>
                            </div>
                            <div class="btn btn-outline-secondary btn-block dc7-btn-left" data-toggle="collapse" :data-target="'#collapse' + globalVersion.id" aria-expanded="false" aria-controls="collapseExample">
                                &nbsp;{{globalVersion.id}}&nbsp;-&nbsp;{{globalVersion.name}}
                                <span class="badge badge-primary badge-pill">{{globalVersion.local_versions_count}}</span>
                            </div>
                        </div>
                        <div class="collapse" :id="'collapse' + globalVersion.id">
                            <div class="card card-body dc7-btn-card">
                                <ul>
                                    <li v-for="(localVersion, index) in globalVersion.localVersions" :key="index">{{localVersion.name}} ({{localVersion.countries}})</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>

                <div v-if="selectedModel > 0" class="form-group pt-3">
                    <label class="btn btn-outline-info dc7-btn-left">
                        <b-form-radio v-model="selectedVersion" name="create_new_version" value="new">
                            I am sure above lists have no suitable version; I'll create a new one
                        </b-form-radio>
                    </label>
                </div>

                <!-- Radio Group Wrapper End -->
                <!-- Version name field -->
                <b-form-input v-if="renderNewVersionName"
                        v-model="newVersionName"
                        name="new_version_name"
                        type="text" class="form-control mt-3"
                        id="new_version_name"
                        placeholder="Enter the name for the new version">
                </b-form-input>
            </form>
            <!-- Footer -->
            <template v-slot:modal-footer="{ok, cancel}">
                <b-button size="sm" variant="secondary" @click="cancel()">
                    Cancel
                </b-button>
                <b-button size="sm"
                        variant="primary"
                        @click="ok()"
                        :disabled="createIsDisabled">
                    Create New Version
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
  export default {
    props: {
        country: {
            type: Object,
            default: {}
        },
        brand: {
            type: Object,
            default: {}
        }
    },

    data () {
        return {
            selectedVersion: null,
            newModelName: null,
            selectedModel: -1,
            models: [],
            localVersions: [],
            globalVersions: [],
            newVersionName: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },

    computed: {
        createIsDisabled: function() {
            if (this.selectedModel === 0) {
                return this.newModelName === null || this.newVersionName === null
                    || this.newModelName === '' || this.newVersionName === '';
            }

            if (this.selectedVersion === 'new') {
                return this.newVersionName === null || this.newVersionName === '';
            }

            return this.selectedVersion === null || this.selectedVersion === '';
        },
        renderNewVersionName: function() {
            if (this.selectedVersion !== 'new') {
                if (this.selectedModel == 0 && this.newModelName !== null && this.newModelName !== '') {
                    if (this.models.find(model => model.text.toLowerCase() == this.newModelName.toLowerCase())) {
                        return false;
                    }

                    return true;
                }

                return false;
            }

            return true;
        },
    },

    mounted () {
        this.getModels();
    },

    methods: {
        getModels: function() {
            axios.get('/api/create-version/get-models/' + this.brand.id)
                .then(response => {
                    this.models = response.data;
                });
        },
        onModelSelectChange: function(event) {
            this.selectedVersion = null;
            this.newVersionName = null;

            if (
                this.newModelName && event &&
                this.newModelName.toLowerCase() !== this.models.find(model => model.value == event).text.toLowerCase()
            ) {
                this.newModelName = null;
            }

            this.getDiscontinuedLocalVersions(event);
            this.getGlobalVersions(event);
        },
        onNewModelInput: function(event) {
            this.selectedModel = 0;
            if (this.models.map(model => model.text.toLowerCase()).includes(event.toLowerCase())) {
                this.onModelSelectChange(this.models.find(model => model.text.toLowerCase() == event.toLowerCase()).value);
            } else {
                this.localVersions = [];
                this.globalVersions = [];
            }
        },
        getDiscontinuedLocalVersions: function(modelId) {
            if ( ! [0, -1, -2, -3].includes(modelId)) {
                axios.get('/api/create-versions/get-local-versions/' + this.country.id + '/' + modelId)
                    .then(response => {
                        this.localVersions = response.data;
                    });
            } else {
                this.localVersions = [];
            }
        },
        getGlobalVersions: function(modelId) {
            if ( ! [0, -1, -2, -3].includes(modelId)) {
                axios.get('/api/create-versions/get-global-versions/' + modelId)
                    .then(response => {
                        this.globalVersions = response.data;
                    });
            } else {
                this.globalVersions = [];
            }
        },
        onOk: function() {
            if (this.selectedModel == 0) {
                if ((this.models.find(model => model.text.toLowerCase() == this.newModelName.toLowerCase()))) {
                    this.$refs.versionForm.model_id.value = (this.models.find(model => model.text.toLowerCase() == this.newModelName.toLowerCase()).value);
                }
            }

            this.$refs.versionForm.submit();
        },
        onCancel: function() {
            this.selectedVersion = null;
            this.newModelName = null;
            this.selectedModel = -1;
            this.localVersions = [];
            this.globalVersions = [];
            this.newVersionName = null;
        }
    },
  }
</script>
